import { Modal } from '@libs/ui/ds'
import { usePlanningFormTranslation } from '@libs/utils/translations'

type Props = {
  shiftId?: number
  formLoading: boolean
  onClickDelete: Function
  createDisabled: boolean
  isCreation: boolean
}
export const ShiftActions = ({
  shiftId,
  formLoading,
  onClickDelete,
  createDisabled,
  isCreation
}: Props) => {
  const { t } = usePlanningFormTranslation()
  return (
    <>
      {shiftId && (
        <Modal.Footer.Danger
          loading={formLoading}
          onClick={() => onClickDelete()}
          fillWidth
          variant='secondary'
        >
          {t('common.app:action.delete')}
        </Modal.Footer.Danger>
      )}
      {!shiftId && (
        <Modal.Footer.Cancel loading={formLoading} fillWidth>
          {t('common.app:action.cancel')}
        </Modal.Footer.Cancel>
      )}
      <Modal.Footer.Success
        disabled={createDisabled}
        loading={formLoading}
        type='submit'
        fillWidth
        data-testid={`${isCreation ? 'create' : 'update'}-shift`}
      >
        {isCreation ? t('common.app:action.add') : t('common.app:action.save')}
      </Modal.Footer.Success>
    </>
  )
}
